export const sexoOptionsArr = [
  { label: 'Macho', sexo: 'Macho' },
  { label: 'Fêmea', sexo: 'Femea' },
  { label: 'Misto', sexo: 'Ambos' },
];

export const getSexo = (sexo: string) => {
  switch (sexo) {
    case 'Femea':
      return 'Fêmea';
    case 'Macho':
      return 'Macho';
    case 'Ambos':
      return 'Ambos';
  }
};

export const getSexoOption = (sexo: string) => {
  const sexoOptions = [
    { label: 'Macho', sexo: 'Macho' },
    { label: 'Fêmea', sexo: 'Femea' },
    { label: 'Ambos', sexo: 'Ambos' },
  ];

  const findSexoOption = sexoOptions.find((option) => option.sexo === sexo);

  return findSexoOption;
};

export const getGeneroOption = (genero: string) => {
  const generoOptions = [
    { label: 'Macho', genero: 'Macho' },
    { label: 'Fêmea', genero: 'Femea' },
    { label: 'Ambos', genero: 'Ambos' },
  ];

  const findGeneroOptions = generoOptions.find((option) => option.genero === genero);

  return findGeneroOptions;
};
